export const getCancellationRequestData = (state) => state.entities.users.cancellationRequestData;
